import { useState } from 'react'
function QuestionForm({ type, label, placeholder, onSave }) {
  const [question, setQuestion] = useState("");
  const [choices, setChoices] = useState(["", ""]);

  const handleChoiceChange = (index, value) => {
    setChoices((prev) => {
      const newChoices = [...prev];
      newChoices[index] = value;
      return newChoices;
    });
  };

  const addChoice = () => setChoices((prev) => [...prev, ""]);

  const handleSave = () => {
    if (!question.trim()) {
      return alert("Please enter a question");
    }

    onSave({
      type,
      question,
      choices: type === "text" ? [] : choices.filter((c) => c.trim() !== ""),
    });

    // Reset form
    setQuestion("");
    setChoices(["", ""]);
  };

  return (
    <div className="space-y-3">
      {type === "text" ? (
        <textarea
          placeholder={placeholder}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          className="w-full border rounded p-2 text-sm min-h-[80px]"
        />
      ) : (
        <input
          type="text"
          placeholder={placeholder}
          value={question}
          onChange={(e) => setQuestion(e.target.value)}
          className="w-full border rounded p-2 text-sm"
        />
      )}

      {type !== "text" &&
        choices.map((choice, index) => (
          <input
            key={index}
            type="text"
            placeholder={`Choice ${index + 1}`}
            value={choice}
            onChange={(e) => handleChoiceChange(index, e.target.value)}
            className="w-full border rounded-lg p-2 text-sm"
          />
        ))}

      {type !== "text" && (
        <button
          onClick={addChoice}
          className="w-full bg-gray-100 text-gray-700 rounded py-1 text-sm"
        >
          + Add Choice
        </button>
      )}

      <button
        onClick={handleSave}
        className="w-full bg-lightPurple text-white rounded py-2 font-medium"
      >
        Save {label}
      </button>
    </div>
  );
}

export default QuestionForm